import { formatMoney } from "../utilities";

const PriceDisplay = {
  addUnavailable: function (element, isMainProduct) {
    if (!element) return;

    const soldOutEl = element.querySelector('.sold-out');

    if (!soldOutEl) {
      const tagToCreate = isMainProduct ? 'h2' : 'p';

      const newElement = document.createElement(tagToCreate);
      newElement.classList.add('sold-out');
      newElement.innerHTML = 'Indisponível';

      //No produto principal, exibe apenas o preço principal e o texto "Indisponível"
      //No product block e compra rápida, exibe apenas o texto "Indisponível"
      if (!isMainProduct) {
        element.innerHTML = '';
      }

      element.appendChild(newElement);
    }
  },

  addPercentage: function(element ,variant) {
    if (!variant.on_sale) return;

    const newElement = document.createElement('p');
    newElement.classList.add('percentage');
    newElement.innerHTML =
      `${Math.round(100 - ((variant.sale_price / variant.price) * 100))}% OFF`;

    element.appendChild(newElement);
  },

  addPrice: function (element, variant, HTMLtag) {
    const newElement = document.createElement(HTMLtag);
    newElement.classList.add('price');

    if (!variant.available) {
      newElement.classList.add('sold-out-price');
    }
    
    newElement.innerHTML = variant.on_sale
      ? `<del>${formatMoney(variant.price)}</del><ins>${formatMoney(variant.sale_price)}</ins>`
      : `<span>${formatMoney(variant.price)}</span>`;

    element.appendChild(newElement);
  },

  addInstallments: function(element, variant, showWithInterest = true, showWithoutInterest = true) {
    if (!variant.installments.length) return;

    // Verifica o tipo de parcelamento
    const withInterest = variant.installments.some(ins => ins.interest) ? variant.installments : [];
    const withoutInterest = variant.installments.filter(ins => !ins.interest);

    if (!withoutInterest.length && !withInterest.length) return;

    let installmentsHtml = '';


    // Modifica os textos de parcelamento baseado nos parametros da função
    if (showWithoutInterest && withoutInterest.length) {
      installmentsHtml += `<span> ${withoutInterest.length}x de <strong>${formatMoney(withoutInterest[withoutInterest.length - 1].price)}</strong> s/juros</span>`;
    }

    if (showWithInterest && withInterest.length) { 
      installmentsHtml += `<span>${installmentsHtml ? 'ou' : ''} em ${withInterest.length}x de <strong>${formatMoney(withInterest[withInterest.length - 1].price)}</strong> com juros</span>`;
    }

    // Cria e insere o elemento
    if (installmentsHtml) {
      const newElement = document.createElement('p');
      newElement.className = 'installments';
      newElement.innerHTML = installmentsHtml;
      element.appendChild(newElement);
    }
  },

  addPIX: function(element, variant, type) {
    if (!pixDiscount) return;

    const newElement = document.createElement('div');
    newElement.classList.add('pix-discount-box');
    if (type === 'main') {
      newElement.classList.add('-main');
    } else {
      newElement.classList.add('-block');
    }

    const pixValue = variant.sale_price - (variant.sale_price / 100 * pixDiscount);
    
    newElement.innerHTML = `
      <span class="pix-icon-wrapper">
        <svg role="img" viewBox="0 0 24 24" class="icon-pix" xmlns="http://www.w3.org/2000/svg"><path d="M5.283 18.36a3.505 3.505 0 0 0 2.493-1.032l3.6-3.6a.684.684 0 0 1 .946 0l3.613 3.613a3.504 3.504 0 0 0 2.493 1.032h.71l-4.56 4.56a3.647 3.647 0 0 1-5.156 0L4.85 18.36ZM18.428 5.627a3.505 3.505 0 0 0-2.493 1.032l-3.613 3.614a.67.67 0 0 1-.946 0l-3.6-3.6A3.505 3.505 0 0 0 5.283 5.64h-.434l4.573-4.572a3.646 3.646 0 0 1 5.156 0l4.559 4.559ZM1.068 9.422 3.79 6.699h1.492a2.483 2.483 0 0 1 1.744.722l3.6 3.6a1.73 1.73 0 0 0 2.443 0l3.614-3.613a2.482 2.482 0 0 1 1.744-.723h1.767l2.737 2.737a3.646 3.646 0 0 1 0 5.156l-2.736 2.736h-1.768a2.482 2.482 0 0 1-1.744-.722l-3.613-3.613a1.77 1.77 0 0 0-2.444 0l-3.6 3.6a2.483 2.483 0 0 1-1.744.722H3.791l-2.723-2.723a3.646 3.646 0 0 1 0-5.156" fill="currentColor"/></svg>
      </span>
      <div class="pix-text-wrapper">
        <span class="pix-price"><strong>${formatMoney(pixValue)}</strong> <span class="pix-label">no pix</span></span>
        <span class="pix-desc">com ${pixDiscount}% de desconto</span>
      </div>
    `;
  
    element.appendChild(newElement);
  },

  addCashback: function(element, variant, type) {
    if (!variant.cashback || !variant.cashback.percentage || variant.cashback.percentage == 0) return;

    const newElement = document.createElement('p');
    newElement.classList.add('cashback');
    newElement.innerHTML =
      type == 'block'
        ? `${formatMoney(variant.sale_price / 100 * variant.cashback.percentage)} de cashback!`
        : `Ganhe até ${formatMoney(variant.sale_price / 100 * variant.cashback.percentage)} de cashback!`
  
    element.appendChild(newElement);
  },

  addPreSale: function(price, type) {
    const priceEl = price.querySelector('.price');
    const product = price.closest('[data-product-box]');
    const element = product.querySelector('[data-pre-sale]');
    let text = 'Preço de pré-venda';

    if(!element) return

    if(element.hasAttribute('data-pre-sale-text')) text = element.getAttribute('data-pre-sale-text');

    const hasPreSale = product.classList.contains('-pre-sale');

    if(type == 'main' && hasPreSale) {
      const flag = document.createElement('div');
      flag.classList.add('flag-pre-sale');
      flag.innerHTML = `<svg class="icon"><use xlink:href="#icon-timer"/></svg> ${text}`;

      priceEl.append(flag);

      const button = product.querySelector('.add-to-cart-button');
      const buttonText = button ? button.getAttribute('data-text-pre-sale') : false;

      if (button) button.innerHTML = buttonText; // Botão comprar com texto pré venda
      
    } else {
      type != 'main' && element.classList.remove('-hidden');
    }
  },

  productMain: function (element, variant) {
    const showWithInterest = true;
    const showWithoutInterest = true;

    element.innerHTML = '';
    
    if (!variant.available) {
      PriceDisplay.addPrice(element, variant, 'h2');
      return;
    }

    PriceDisplay.addPercentage(element, variant);
    PriceDisplay.addPrice(element, variant, 'h2');
    PriceDisplay.addInstallments(element, variant, showWithInterest, showWithoutInterest);
    PriceDisplay.addPIX(element, variant, 'main');
    PriceDisplay.addCashback(element, variant, 'main');
    PriceDisplay.addPreSale(element, 'main');
  },

  productBlock: function(element, variant) {
    const showWithInterest = false;
    const showWithoutInterest = true;

    element.innerHTML = '';

    PriceDisplay.addPercentage(element, variant);
    PriceDisplay.addPrice(element, variant, 'p');
    PriceDisplay.addInstallments(element, variant, showWithInterest, showWithoutInterest);
    PriceDisplay.addPIX(element, variant, 'block');
    PriceDisplay.addPreSale(element, 'block');
  },
}

export default PriceDisplay
